export const URL_ROOT = "/";
export const URL_DASHBOARD = "/dashboard";
export const AUTH_CALLBACK_URL = "/auth/nid/callback";
export const URL_AUTH_START = "/auth/start";

export const PASSPORT_SCREEN_URL = "/passport-info";
export const REGISTRATION_ADDRESS_SCREEN_URL = "/registration-address";
export const DRIVING_LICENSE_SCREEN_URL = "/driving-license";
export const MOVABLE_ESTATE_SCREEN_URL = "/movable-estate";
export const REAL_ESTATE_SCREEN_URL = "/real-estate";
export const REAL_ESTATE_LAND_SCREEN_URL = "/real-estate/land";
export const ORGANIZATIONS_SCREEN_URL = "/organizations";
export const TAX_REGISTRATION_DETAILS_SCREEN_URL = "/organizations/tax-details";
export const FAMILY_STATUS_SCREEN_URL = "/family-status";
export const JOB_SCREEN_URL = "/job";
export const INCOME_TAX_SCREEN_URL = "/income-tax";
export const VIOLATIONS_SCREEN_URL = "/violations";
export const WEAPONS_SCREEN_URL = "/weapons";
export const SOCIAL_STATUS_SCREEN_URL = "/social-status";
export const DISABILITY_SCREEN_URL = "/social-status/disability";
export const CES_SCREEN_URL = "/ces";
export const NOTARY_SCREEN_URL = "/notary";
export const SCHOOL_SCREEN_URL = "/school";
export const REQUEST_HISTORY_SCREEN_URL = "/requests-history";
export const REQUEST_HISTORY_DETAIL_SCREEN_URL = "/requests-history/detail";
export const NOTIFICATIONS_SCREEN_URL = "/notifications";
export const NOTIFICATION_DETAIL_SCREEN_URL = "/notifications/detail";
export const NOTIFICATION_SETTINGS_SCREEN_URL = "/notifications/settings";
export const PENSION_SCREEN_URL = "/pension";
